import Http from './http';
import Cookies from 'js-cookie';

const OFFICE_TOKEN_COOKIE = 'officeToken';
/** Align with Office API TIME_REMAINING (720 minutes). */
const REFRESH_BUFFER_SECONDS = 12 * 60 * 60;

export function getOfficeTokenFromCookie() {
  return Cookies.get(OFFICE_TOKEN_COOKIE) || '';
}

export function refreshOfficeToken() {
  return Http.authApi().post('/user/office-token/refresh');
}

/**
 * Decode JWT payload without verifying signature (client-side usability check only).
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

/**
 * Token is usable when present, structurally valid, and not within/past the refresh buffer.
 */
export function isOfficeTokenUsable(token) {
  if (!token || typeof token !== 'string' || !token.trim()) {
    return false;
  }

  const payload = decodeJwtPayload(token.trim());
  if (!payload || typeof payload.exp !== 'number') {
    return false;
  }

  const nowSeconds = Math.floor(Date.now() / 1000);
  return payload.exp > nowSeconds + REFRESH_BUFFER_SECONDS;
}



// WEBPACK FOOTER //
// ./src/js/services/officeToken.js